<template>
  <footer>
    <div class="ys_footer ys">
      <div class="ys_content top">
        <ul>
          <li class="title">微唯宝</li>
          <div class="flow">
            <li @click="selectNav(item)" v-for="(item,index) in navList" :key="index">{{item.nav_name}}</li>
          </div>
        </ul>
        <ul>
          <li class="title">行业解决方案</li>
          <li @click="navTo('https://wiwipu.com','',true)">蔬果云Saas系统</li>
          <li @click="navTo('https://www.douhuomall.com','',true)">微唯宝供应链</li>
         </ul>
        <ul>
          <li class="title">联系我们</li>
          <li><i class="el-icon-phone-outline"></i><label>联系电话：</label><span>189-7318-3401</span></li>
          <li><i class="el-icon-location-outline"></i><label>联系电话2：</label><span>13507463360</span></li>
          <li><i class="el-icon-location-outline"></i><label>公司地址：</label><span>湖南省长沙市开福区万达广场A座32005</span></li>
        </ul>
        <!-- <ul @click="$bus.$emit('registerPopup')" v-if="!sysInfo.sys_id||sysInfo.sys_id==11">
          <li class="title">用户注册</li>
          <div class="top_btn"><i class="iconfont">&#xe62e;</i>用户注册</div>
        </ul> -->
        <ul></ul>
        <ul class="top_right">
          <li class="title">企业服务号</li>
          <li class="server">
            <div class="server_item">
              <img src="@/static/footer_02.png" alt="">
              <div>企业抖音号</div>
            </div>
            <div class="server_item">
              <img src="@/static/footer_03.png" alt="">
              <div>供应链抖音号</div>
            </div>
          </li>
          <li>提供全场景技术解决方案及全品类电商货源</li>
        </ul>
      </div>
    </div>
    <div class="ipc">
      <small>Powered by 微唯宝 ©2011-2023 湘ICP备15019552号-1 湘公网安备 43060202000167号</small>
    </div>
  </footer>
</template>
<script>
import {mapState} from 'vuex'
import {getMsg} from '@/utils/crossTagMsg'
export default {
  data(){
    return {
      navList : []
    }
  },
  computed:{
    ...mapState(['sysInfo'])
  },
  mounted(){
    setTimeout(()=>{
        let list = getMsg('navBarList') || {};
        this.navList = (list.payload||[]).reduce((arr, item) => {
          arr.push(item)
          arr = arr.concat(item.child)
          return arr;
        }, []);
    },2000)
  }
}
</script>

<style scoped lang="scss">
  footer {
    .ys_footer {
      background-color: #2C2D32;
      color: #fff;
      padding: 80px 0;
      .top {
        display: flex;
        justify-content: space-between;
        ul {
          width: max-content;
          &:nth-child(1){
            width: 25%;
            overflow: hidden;
            li{
              padding-left: 16px;
              margin-right: 16px;
              &:hover {
                cursor: pointer;
                color: var(--theme-color);
              }
            }
          }
          &:nth-child(2){
            width: 10%;
            li:hover {
                cursor: pointer;
                color: var(--theme-color);
            }
          }
          &:nth-child(3){
            width: 22%;
            li{
               display: flex;
               i{line-height: 25px;}
               span{width: 68%;}
            }
          }
          &:nth-child(4){border-left: 2px solid #616369;}
          li {
            list-style: none;
            color: #9E9FA1;
            padding-bottom: 15px;
            position: relative;
            &.title{
              font-weight: 500;
              font-size: 20px;
              color: #ECEEED;
            }
            span{color: #ECEEED;}
            label{white-space: nowrap;}
          }
          .flow{
            width: calc(100% + 16px);
            display: flex;
            flex-wrap: wrap;
            margin-left: -5px;
            li::after{
              content: "";
              position: absolute;
              left: 0;
              width: 0px;
              height: 22px;
              border: 1px solid;
              opacity: 0.3;
              border-image:linear-gradient(315deg, #dddddd00, #ffffffcc, #dddddd00) 2 2;
            }
          }
        }
        &_right{
          width: 14%!important;
          .server{
            display: flex;
            &_item{
              &:first-child{
                margin-right: 20px;
              }
            }
            img{width: 100px;height: 100px;}
          }
        }
        &_btn{
          background-color: var(--theme-color);
          width: 182px;
          height: 60px;
          display: flex;align-items: center;justify-content: center;
          color: #fff;
          font-size: 18px;
          border-radius: 10px;
          cursor: pointer;
          i{
            color: #fff;
            font-size: 38px;
            margin-right: 10px;
          }
        }
      }
    }

    .ipc {
      line-height: 3rem;
      text-align: center;
      width: 100%;
      background-color: #26272B;
      color: #fff;

      small {}
    }
  }
  @media (max-width: 1850px) {
    .top{
      width: 1450px;margin: 0 auto;
    }
  }
  @media (max-width: 1650px) {
    .top{
      width: 1200px;margin: 0 auto;
      
    }
  }
</style>
